import { userService } from '@/resources/UserService.js';
import { router } from '@/router';
import vm from '../main';

const emptyObject = {};

const token = localStorage.getItem('auth_token');
const state = token
    ? { status: { loggedIn: true }, user: { token: token } }
    : { status: {}, user: {} };


const getters = {
    loggedIn: state => state.status.loggedIn,
    username: state => state.user,
    isAdministrator: state => state.user.roles == "Administrator",
};

const actions = {
    async login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', { username });

        try {
            const result = await userService.logIn(username, password);
            console.log(result, "Result from login")
            //vm.$snotify.success('Login successful', 'Login');
            commit('loginSuccess', result);
            router.push('/');
        } catch (error) {
            //vm.$snotify.warning('Wrong user or password', 'Login');
            commit('loginFailure', error);
            dispatch('alert/error', error, { root: true });
        }
    },
    logout({ commit }) {
        userService.logOut();
        commit('logout');
    }
}

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = {
            username: user
        };
    },
    loginSuccess(state, result) {
        state.status = { loggedIn: true };
        state.user = {
            ...state.user,
            ...result,
            roles: result.data.roles
        }

    },
    loginFailure(state) {
        state.status = {};
        state.user = {};
    },
    logout(state) {
        state.status = {};
        state.user = {};
    },
}

export const account = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  